import { mergeOptions } from "../../helpers/common/merge-options";

export interface FormFieldOptions {
	showClearButton: boolean;
	toggleIconVisibility: boolean;
}

export class FormField {
	static options: FormFieldOptions = {
		showClearButton: false,
		toggleIconVisibility: true,
	}

	private options: FormFieldOptions;
	private input: HTMLInputElement | HTMLSelectElement;
	private clear: HTMLElement | null;
	private icon: HTMLElement | null;

	constructor(private element: HTMLElement, options?: Partial<FormFieldOptions>) {
		this.options = mergeOptions(FormField, options, element);

		const input = this.element.querySelector<HTMLInputElement | HTMLSelectElement>('.js-form-field-input');
		this.clear = this.element.querySelector<HTMLElement>('.js-form-field-clear');
		this.icon = this.element.querySelector<HTMLElement>('.js-form-field-icon');

		if (input) {
			this.input = input;
			this.init();
		}
	}

	init(): void {
		this.checkValue();
		this.input.addEventListener('input', () => this.checkValue());
		this.input.addEventListener('change', () => this.checkValue());
		this.clear?.addEventListener('click', () => {
			this.input.value = ''
			this.input.dispatchEvent(new InputEvent('keyup'))
		})
	}

	private checkValue() {
		const state = this.input.value.length > 0;
		this.input.classList.toggle('is-filled', state);

		if (this.options.toggleIconVisibility) {

			this.icon?.classList.toggle('is-hidden', state);
			this.clear?.classList.toggle('is-hidden', !state);
		}
	}
}
